import React from "react";
import { connect } from "react-redux";
import { CallbackComponent } from "redux-oidc";
import { push } from "connected-react-router";

import userManager from "../../services/UserManager";

class SigninCallbackPage extends React.Component {
    render() {
        return (
            <CallbackComponent
                userManager={userManager}
                successCallback={() => this.props.push("/")}
                errorCallback={error => {
                    this.props.push("/");
                    console.error(error);
                }}
            >
                <div>Redirecting...</div>
            </CallbackComponent>
        );
    }
}

const mapDispatchToProps = {
    push: push
};

export default connect(null, mapDispatchToProps)(SigninCallbackPage);